import { generateApiPath } from '@scouts/helpers'

import { CustomerTypeUpdateDTO, UserProfileDTO, UserProfileModelDTO } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'
import { ApiTags } from '../tags'

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProfile: builder.query<UserProfileDTO, { userId: number | null }>({
            query: ({ userId }) => ({
                method: 'GET',
                url: generateApiPath(ENDPOINTS.PROFILE.GET, { userId: userId ?? '' }),
            }),
            providesTags: [ApiTags.Profile],
        }),
        updateProfile: builder.mutation<UserProfileModelDTO, UserProfileModelDTO>({
            query: ({ id, ...rest }) => ({
                method: 'PUT',
                url: generateApiPath(ENDPOINTS.PROFILE.PUT, { userId: id }),
                data: { id, ...rest },
            }),
            invalidatesTags: [ApiTags.Profile],
        }),
        updateCustomerType: builder.mutation<UserProfileModelDTO, { userId: number } & CustomerTypeUpdateDTO>({
            query: ({ userId, ...rest }) => ({
                method: 'PUT',
                url: generateApiPath(ENDPOINTS.PROFILE.PUT_CUSTOMER_TYPE, { userId }),
                data: rest,
            }),
            invalidatesTags: [ApiTags.Profile],
        }),
    }),
})

export const { useGetProfileQuery, useUpdateProfileMutation, useUpdateCustomerTypeMutation } = extendedApi

export const invalidateProfile = () => apiSlice.util.invalidateTags([ApiTags.Profile])
